import { API, baseClient } from "../index";

/**
 * Textos del juego (p. ej. para vídeo intro, escenarios). Público.
 * @param {{ game?: string, key?: string }} params - game: id del juego; key: filtro por clave
 */
export const getTexts = (params = {}) => {
	return baseClient().get(`${API}/text`, { params });
};
